<template>
  <div>
    <b-form-checkbox
      id="select-all-menu-device-permissions"
      v-model="allSelected"
      name="select-all-menu-device-permissions"
      class="text-capitalize mt-2"
      switch
    >
      {{ $t('hanwha_dvr.groups_permissions.select_all') }}
    </b-form-checkbox>
    <b-list-group>
      <b-list-group-item v-for="(option, index) in devicekOptions" :key="index">
       <!--  <pre>{{ itemData.DeviceMenuAccess }}</pre> -->
        <div v-if="option.children">
          <p class="h5 mb-1">{{ option.label }}</p>
          <div class="row">
            <div
              v-for="(optionChildren, indexChildren) in option.children"
              :key="indexChildren"
              class="col-6"
            >
              <b-form-checkbox
                :id="`option-device-${optionChildren.value}`"
                v-model="itemData.DeviceMenuAccess"
                :name="option.value"
                class="text-capitalize"
                switch
                :value="optionChildren.value"
              >
                {{ optionChildren.label }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <b-form-checkbox
          v-else
          :id="`option-device-${index}`"
          v-model="itemData.DeviceMenuAccess"
          :name="option.value"
          class="text-capitalize"
          switch
          :value="option.value"
        >
          {{ option.label }}
        </b-form-checkbox>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import { useArraySelectAllSwitch, flattenOptionValues } from "./useSelectAllSwitch";

export default {
  props: {
    itemData: {
      type: Object
    }
  },
  setup (props) {
    //COMPOSABLES
    const { t } = useI18nUtils();

    //DATA
    const devicekOptions = [
      {
        label: t('hanwha_dvr.groups_permissions.menu.device.storage_device'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.device.device_format'),
            value: 'DeviceFormat'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.device.smart'),
            value: 'SMART'
          }
        ]
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.device.text'),
        children: [
          {
            label: t('hanwha_dvr.groups_permissions.menu.device.device'),
            value: 'POSConf'
          },
          {
            label: t('hanwha_dvr.groups_permissions.menu.device.event'),
            value: 'POSEventConf'
          }
        ]
      },
      {
        label: t('hanwha_dvr.groups_permissions.menu.device.monitor'),
        value: 'Monitor'
      },
    ];

    const { allSelected } = useArraySelectAllSwitch(
      props.itemData,
      "DeviceMenuAccess",
      flattenOptionValues(devicekOptions)
    );

    return { allSelected, devicekOptions }
  }
}
</script>
